export const urls = {
  playerNameCreate: () => `playerNameCreate`,
  playerNameList: () => `playerNameList`,
};
